export const getSubscriptionLobbyContent = async (
  abortController: AbortController
): Promise<SubscriptionLobbyContent> => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/SubscriberCompetition/GetsubscriptionLobbyContent`,
    {
      signal: abortController.signal,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return response.json();
};

export const getSubscriptionPastWinners = async (date: string): Promise<SubscriptionPastWinners> => {
  const url = new URL(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/SubscriberCompetition/GetSubscriptionPastWinners`);
  url.searchParams.append("date", date);
  const response = await fetch(url.toString(), {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.json();
};

export const getSubscriptionHallOfFame = async (): Promise<SubscriptionHallOfFame> => {
  const url = new URL(`${process.env.NEXT_PUBLIC_HOST}/umbraco/botb/SubscriberCompetition/GetSubscriptionHallOfFame`);
  const response = await fetch(url.toString(), {
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response.json();
};
